import React from 'react';
import { MaintenanceBanner } from '@mobilitystore/components-interface';
import {
  SELLER_TENANT_ID,
  TENANT,
  MAINTENANCE_CONFIG
} from '../../../actions/configuration';
import { REGION } from '../../../data/idConstants';
import { getEnvironment } from '../../../utils';
import './index.scss';

const MaintenanceWrapper = ({ onVisibilityChange, onClose }) => {
  // Get region from environment variable, map IN to APAC for banner component
  const getRegion = () => {
    const envRegion = process.env.REACT_APP_REGION;

    // Only IN region needs special mapping to APAC, others use their own code
    return envRegion === REGION.IN.CODE ? 'APAC' : envRegion;
  };

  // Get tenant ID from configuration, fallback to 'mkos' if not available
  const getTenantId = () => {
    return SELLER_TENANT_ID || TENANT.MKOS;
  };

  return (
    <div className='maintenance-wrapper'>
      <MaintenanceBanner
        applicationId={MAINTENANCE_CONFIG.APPLICATION_ID}
        environment={getEnvironment(process.env.REACT_APP_ENVIRONMENT)}
        tenantId={getTenantId()}
        region={getRegion()}
        refreshInterval={MAINTENANCE_CONFIG.REFRESH_INTERVAL}
        enableRealTimeUpdates={MAINTENANCE_CONFIG.ENABLE_REAL_TIME_UPDATES}
        persistDismissalState={MAINTENANCE_CONFIG.PERSIST_DISMISSAL_STATE}
        onVisibilityChange={(visibility) => {
          if (onVisibilityChange) {
            onVisibilityChange(visibility);
          }
        }}
        onClose={() => {
          if (onClose) {
            onClose();
          }
        }}
      />
    </div>
  );
};

export default MaintenanceWrapper;
